<template>
  <div class="framer-1lju1ay" data-framer-name="FAQ section" id="faq" name="FAQ section">
    <div class="framer-a5n46o" data-framer-name="Title content" name="Title content">
      <div class="framer-156wxr2" data-framer-name="Title" name="Title">
        <div class="framer-1wmxp7b"
          style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
          data-framer-component-type="RichTextContainer">
          <h2 class="framer-text framer-styles-preset-gx26df" data-styles-preset="k3Ea6rV_p"
            style="--framer-text-alignment:center">Frequently Asked Questions</h2>
        </div>
      </div>
    </div>
    <div class="framer-s4c5ox">
      <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
        <faq-question v-for="(question, key)  in faqQuestionsList" :key="key" :titleFaqQuestion="question.titleFaqQuestion" :descFaqQuestion="question.descFaqQuestion" :projectFlowImage="question.projectFlowImage"/>
      </div>
    </div>
  </div>
</template>
<script>
import projectflow from "@/assets/ProcessFlowProject.png";

export default {
  name: 'part-7-landing-page',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionsList: [
        {
          titleFaqQuestion: 'What is the Smart Technology Uptake programme (Smart Tech Up)?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">The Smart Technology Uptake
              programme is an initiative by the Ministry of International Trade and Industry (MITI) Malaysia to encourage
              and support local businesses, particularly <strong class=\"framer-text\">Small and Medium Enterprises (SMEs)
                and Mid-tier Companies</strong> (MTCs), in adopting smart technologies to enhance their productivity and
              competitiveness.</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">The program aims to accelerate the
              transformation of 3,000 companies into smart factories by 2030.</em></p>`
        },
        {
          titleFaqQuestion: 'Who is eligible to participate in this programme?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Malaysian-owned businesses, especially
              Small and Medium Enterprises (SMEs) and Mid-tier Companies, operating in manufacturing and related services
              sectors are eligible to participate, with the following criteria:</em></p>
          <ol class=\"framer-text\">
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Incorporated under the Companies Act,
                  2016.</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">At least 51%
                  Malaysian owned.</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">In operation for at least 3
                  years.</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Valid business license from local
                  authority.</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Manufacturers engage in manufacturing
                  activities with valid Manufacturing License (ML) or Letter for Exemption of ML from MIDA in compliance with
                  the Industrial Coordination Act, 1975</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Manufacturing Related Services</em>
              </p>
            </li>
          </ol>`
        },
        {
          titleFaqQuestion: 'What types of smart technologies are covered under this programme?',
          descFaqQuestion: ` <p class=\"framer-text framer-styles-preset-11do9gc\">The programme covers a wide range of smart technologies, including
              but not limited to:</p>
            <ul class=\"framer-text\">
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Internet of Things (IoT)</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Artificial Intelligence (AI)</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Big Data Analytics</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Cloud Computing</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Autonomous Robotics&nbsp;</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Cybersecurity&nbsp;</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Augmented Reality</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Advance Material</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">System Integration</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Simulation</em></p>
              </li>
              <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
                <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Additive manufacturing.</em></p>
              </li>
            </ul>`
        },
        {
          titleFaqQuestion: 'What kind of support does the programme offer?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\">The programme typically offers:</p>
          <ul class=\"framer-text\">
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Financial assistance or grants</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Technical consultancy and advisory
                  services</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Training and capacity building</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Networking opportunities with
                  technology providers</em></p>
            </li>
          </ul>`
        },
        {
          titleFaqQuestion: 'How can my company apply for the programme?',
          descFaqQuestion:  `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Applications are submitted through Smart
              Tech Up Portal: smarttechup.sirim.my</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Detailed application procedures and
              required documents will be provided in the programme guidelines.</em></p>`
        },
        {
          titleFaqQuestion: 'Is there any fee charged during registration?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">There is no fee charged for registration.
            However, a fee of RM8,000.00 is charged for the Onsite Smart Factory (OSFA) which will be conducted by certified
            assessors. This assessment is required to verify the information stated in the Online Self-Assessment. It also provides detailed on-site evaluation, recommendations, project identification as well as project and training identification. This fee
            is<strong class=\"framer-text\"> non-refundable</strong>. However, if the applicant is eligible to participate in
            the program, this cost will be absorbed into the overall project cost.</em></p>`
        },
        // {
        //   titleFaqQuestion: 'Is there a deadline for applications?',
        //   descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Applications are open from 4th December
        //       2024 to 28th February 2025. However, please note that if the number of eligible companies reaches the target
        //       before the end date, the application period may close early.</em></p>
        //   <p class=\"framer-text framer-styles-preset-11do9gc\"><br class=\"framer-text trailing-break\"></p>
        //   <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">For the most up-to-date information,
        //       kindly refer to the portal.</em></p>`
        // },
        {
          titleFaqQuestion: 'How are applications evaluated?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">After successful registration, the
            applicant will do a self-assessment exercise. This assessment consists of 17 dimensions from 3 shift factors
            namely People, Process and Technology. &nbsp; The purpose of this assessment is to determine the level of
            readiness and adoption of the company to Industry 4.0.&nbsp;</em></p>
        <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Following the self -assessment, an onsite
            factory assessment (OSFA) will be conducted to verify the information provided in the Online Self-Assessment.
            <strong class=\"framer-text\">If the final score achieved during the OSFA </strong>meets the specified criteria, the
            applicant will be eligible to participate in this program.</em></p>`
        },
        {
          titleFaqQuestion: 'What is the maximum funding amount available?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">This is a technology adoption program
              where the <strong class=\"framer-text\">government provides 50% financial assistance</strong> towards the project
              cost, <strong class=\"framer-text\">up to a maximum of RM500,000.00 (including Project and training)</strong>. Applicants <strong
                class=\"framer-text\">must commit to funding the remaining 50% </strong>of the project value for their application
              to be considered.</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">This program provides a platform to
              facilitate applicants who need financial assistance and request for loan to cover the project cost.</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">There are 8 Financial Institutions (FI)
              participating in this program to facilitate applicants who need loans to participate in this program.</em></p>
          <ol class=\"framer-text\">
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">MIDF</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">Bank Muamalat</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">Affin Bank</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">Alliance Bank</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">SME Bank</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">Exim Bank</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">MBSB Bank</p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">OCBC Bank</p>
            </li>
          </ol>`
        },
        {
          titleFaqQuestion: 'How long does the programme run?',
          descFaqQuestion:   `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Program on a year to year basis depending on the allocation - project duration is 8 months post project after project completion.</em></p>`
        },
        {
          titleFaqQuestion: 'How does this programme differ from other MITI technology adoption initiatives?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">The Smart Technology Uptake programme
              specifically focuses on advanced, 'smart' technologies that can significantly transform business operations. It
              may offer more specialized support compared to general technology adoption programmes.</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Implementation must be based on Industry
              4.0 technology pillars as below:&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">1. Internet of Things (IoT)&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">2. Artificial Intelligence (AI)&nbsp;</em>
          </p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">3. Big Data Analytics&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">4. Cloud Computing&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">5. Autonomous Robotics &nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">6. Cybersecurity &nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">7. Augmented Reality&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">8. Advance Material&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">9. System Integration&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">10. Simulation</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">11. Additive manufacturing</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">&nbsp;</em></p>
          <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\"><strong class=\"framer-text\">Capacity
                Building:</strong></em></p>
          <ol class=\"framer-text\">
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Technology training related to smart
                  factories.</em></p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\"><em class=\"framer-text\">Leadership training related to
                  understanding smart factories.</em></p>
            </li>
          </ol>`
        },
        {
          titleFaqQuestion: 'What are the criteria and requirements to apply for Crowd Innovators?',
          descFaqQuestion: `<ol class=\"framer-text\">
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">At least 2 years in operation.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Majority Malaysian owned company (at least 51%).</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Financially stable: financial stability to ensure they can support long-term commitments.(2 years Financial reports). </em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Technological partners needs to have internal development capability and not just traders or agents for overseas technological solutions.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Compatibility & Interoperability: Ensure compatibility with existing systems and technologies and able to operate seamlessly with variety of other platforms and technologies.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Scalability: The solution must be scalable to accommodate future growth and increased demand.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Industry Experience: Prefer providers with experience in your industry to ensure they understand specific requirements and challenges.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Track Record: Review the provider’s history, including case studies, client testimonials, and references.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Innovation: Look for providers that are leaders in innovation, keeping up with the latest technological advancements. </em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Customisation: Able of the provider to tailor solutions to meet specific needs.</em>
              </p>
            </li>
            <li data-preset-tag=\"p\" class=\"framer-text framer-styles-preset-11do9gc\">
              <p class=\"framer-text framer-styles-preset-11do9gc\">
                <em class=\"framer-text\">Customer Support and Service Level Agreements (SLAs) has to be signed. Support Availability: Ensure the provider offers comprehensive customer support, including 24/7 availability if necessary.</em>
              </p>
            </li>
          </ol>`
        },{
          titleFaqQuestion: 'What is the Project process flow?',
          descFaqQuestion: `<p class=\"framer-text framer-styles-preset-11do9gc\">
              <em class=\"framer-text\">The flow is as below:</em>
            </p>`,
          projectFlowImage: true
        }
      ],
      projectflow
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/sfera/components/Part7LandingPage/index.vue